import appLocaleData from 'react-intl/locale-data/zh';
import zhMessages from '../locales/zh-Hans.json';

const ZhLan = {
    messages: {
        ...zhMessages
    },
    locale: 'zh-Hans-CN',
    data: appLocaleData
};
export default ZhLan;



// WEBPACK FOOTER //
// ./lngProvider/entries/zh-Hans-CN.js